import React, { useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import CircularProgress from "@mui/material/CircularProgress";

import bgImage from "assets/images/StartingmyFoundeverLife.jpg";

const CountryDropdown = () => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  //const [email, setEmail] = useState(""); // State for the email
  const [loading, setLoading] = useState(false); // State for loading
  //const navigate = useNavigate();

  useEffect(() => {
    const retrievedData = JSON.parse(localStorage.getItem("sesion"));

    const retrievedCountries =
      retrievedData?.rols?.map((role) => role.country.countryName) || [];
    setCountries(retrievedCountries);
  }, []);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCountry(selectedValue);
  };

  const handleOkClick = async () => {
    if (!selectedCountry) {
      alert("Please select a country.");
      return;
    }

    setLoading(true);
    localStorage.setItem("selectedCountry", selectedCountry);

    const routes = {
      "Costa Rica": "/views/countries/cr/home",
      Mexico: "/views/countries/mx/home",
      Peru: "/views/countries/pe/home",
      Colombia: "/views/countries/co/home",
    };

    const redirectRoute = routes[selectedCountry] || "/views/home";
    window.location.href = redirectRoute;
  };

  return (
    <MKBox
      position="absolute"
      top={0}
      left={0}
      zIndex={1}
      width="100%"
      minHeight="100vh"
      sx={{
        backgroundImage: ({
          functions: { linearGradient, rgba },
          palette: { gradients },
        }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <MKBox
        px={1}
        width="100%"
        height="100vh"
        mx="auto"
        position="relative"
        zIndex={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Card>
          <MKBox
            style={{ background: "#4b4bf9", color: "#fff" }}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={6}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Select your country
            </MKTypography>
          </MKBox>
          <MKBox pt={4} pb={3} px={3}>
            <MKBox component="form" role="form">
              <MKBox mb={2}>
                <InputLabel id="country-select-label">
                  Select Country
                </InputLabel>
                <Select
                  labelId="country-select-label"
                  id="country-select"
                  sx={{ height: "3rem" }}
                  value={selectedCountry}
                  onChange={handleChange}
                  fullWidth
                >
                  <MenuItem value="">--Please choose an option--</MenuItem>
                  {[...new Set(countries)].map((country) => (
                    <MenuItem key={country} value={country}>
                      {country}
                    </MenuItem>
                  ))}
                </Select>
              </MKBox>
              <MKBox mt={4} mb={1}>
                <MKButton
                  style={{ background: "#4b4bf9", color: "#fff" }}
                  variant="gradient"
                  color="warning"
                  fullWidth
                  onClick={handleOkClick}
                  disabled={loading}
                  startIcon={
                    loading && <CircularProgress size={20} color="inherit" />
                  }
                >
                  {loading ? "Loading..." : "OK"}
                </MKButton>
              </MKBox>
            </MKBox>
          </MKBox>
        </Card>
      </MKBox>
    </MKBox>
  );
};

export default CountryDropdown;
